<template >
   <div id="google_translate_element"></div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'TranslatePage',
    data(){
        return{
           
        };
        
    },
    components:{
            
    },
    mounted :function(){ 
        document.querySelector("[name='google']").remove();
        document.documentElement.setAttribute("translate", "yes");       
        this.$nextTick(()=>{			
            this.googleTranslateInit();
            
		});
		let externalScript = document.createElement('script')
		externalScript.setAttribute('src', 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit')
        document.head.appendChild(externalScript)        
    },
    created:function(){
          
    },
    computed:{
        
    },
	methods:{
        googleTranslateInit: function() {
            let checkIfGoogleLoaded = setInterval(() => {
                if (google.translate.TranslateElement != null) {
                    clearInterval(checkIfGoogleLoaded);
                    this.googleTranslateElement('google_translate_element');
                }
            }, 1000);
        },

        googleTranslateElement: function(id) {
            //new google.translate.TranslateElement({pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.SIMPLE}, id);
            new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
        }        
    }
};
</script>
<style>
#colorlib-aside .colorlib-footer span {
    display: inherit !important;
}
.goog-logo-link {
   display:block !important;
}
.goog-te-gadget {
   line-height: 2px !important;
   color: transparent !important;
}
.goog-te-gadget .goog-te-combo {
   color: #000000 !important;
}
.VIpgJd-ZVi9od-l4eHX-hSRGPd{
   /*  display: none !important; */
}
#google_translate_element {
    margin-top: 0px !important;
}
</style>